import { all } from 'redux-saga/effects'
import { combineReducers } from 'redux'
import UserSliceReducer from '../../app/modules/auth/redux/AuthSlice'
import PageLinkReducer from './PageTitleSlicer'
import HaberReducer from '../../app/modules/salesPediaMain/redux/haberlerSlicer'
import ProductHierarchyReducer from '../../app/modules/salesPediaMain/redux/productHierarchySlicer'
import * as auth from '../../app/modules/auth'
import SetMainLoadingSlicer from './loadingSlice'

export const rootReducer = combineReducers({
  auth: auth.reducer,
  userReducer: UserSliceReducer,
  pageLinkReducer: PageLinkReducer,
  haberReducer: HaberReducer,
  productHierarchyReducer: ProductHierarchyReducer,
  setMainLoadingSlicer: SetMainLoadingSlicer

})

export type RootState = ReturnType<typeof rootReducer>

export function* rootSaga() {
  yield all([auth.saga()])
}



